import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section className="hero" id="accueil">
      <div className="hero-background">
        <img src="/slide1.png" alt="Octopus AI Background" className="hero-bg-image" />
      </div>
      <div className="hero-overlay"></div>
      <div className="hero-container">
        <div className="hero-content">
          <p className="hero-subtitle">Nous fusionnons créativité humaine et intelligence artificielle</p>
          <h1 className="hero-title">
            <span className="highlight">Viviworks.IA</span> : L'intelligence artificielle au service du web
          </h1>
          <p className="hero-description">
            Chez Viviworks.IA, nous combinons expertise humaine et intelligence artificielle pour créer des solutions digitales uniques. 
            De la conception de sites web à la rédaction et au design graphique, chaque projet est optimisé par l'IA 
            pour offrir performance, créativité et impact durable.
          </p>
          <button className="btn-primary hero-btn">Découvrir nos solutions</button>
        </div>
      </div>
    </section>
  );
}

export default Hero;

